import { render, staticRenderFns } from "./donation-notes.vue?vue&type=template&id=736033df&"
import script from "./donation-notes.vue?vue&type=script&lang=js&"
export * from "./donation-notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports